import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { auth } from "./auth";

export default createStore({
    state: {
        menu: [
            { path: "/", name: "Home" },
            { path: "/import", name: "Load Master" },
            { path: "/marketlist", name: "Marketlist" },
            { path: "/stockfinance", name: "Stockfinance" },
            { path: "/load", name: "Load PR" },
            { path: "/pr", name: "Purchase Requisition" },
            { path: "/pr-detail/:id", name: "PR Detail" },
            { path: "/po", name: "Purchase Order" },
            { path: "/po-detail/:id", name: "PO Detail" },
            { path: "/profile", name: "Profile" },
            { path: "/pr", name: "Manage User" },
            { path: "/pr", name: "Approve PR" },
            { path: "/pr", name: "Reject PR" },
            { path: "/pr", name: "Revision PR" },
            { path: "/stock", name: "Stock" },
        ],
    },
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
    },

    plugins: [
        createPersistedState({
            paths: ["auth"],
        }),
    ],
});
